import React from 'react';

const ShippingPolicy = () => {
  return (
    <div className="policy-page-container">
      {/* Breadcrumb Section */}
      <div className="policy-breadcrumb">
        <div className="breadcrumb-content">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb-list">
              <li className="breadcrumb-item">
                <a href="/">Home</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Shipping Policy
              </li>
            </ol>
          </nav>
          <h1 className="breadcrumb-title">Shipping Policy</h1>
        </div>
      </div>

      <div className="policy-wrapper">
        <div className="policy-content">
          {/* Header Section */}
          <header className="policy-header">
            <p className="policy-update-date"><strong>Updated effective from 1st April, 2022</strong></p>
            <div className="policy-notice-banner">
              <h2>We deliver products across India through trusted courier partners.</h2>
            </div>
          </header>

          {/* Policy Sections */}
          <div className="policy-sections">
            <section className="policy-section">
              <h2>Processing Time</h2>
              <p>
                Orders are usually processed within <strong>1–2 business days</strong> after payment confirmation.
              </p>
            </section>

            <section className="policy-section">
              <h2>Shipping Time</h2>
              <p>
                Standard delivery takes <strong>3–7 business days</strong>, depending on the destination. 
                Remote areas may take longer.
              </p>
            </section>

            <section className="policy-section">
              <h2>Tracking</h2>
              <p>
                Once dispatched, you'll receive a tracking ID and courier details via email or SMS.
              </p>
            </section>

            <section className="policy-section">
              <h2>Delays</h2>
              <p>
                Delivery may be delayed due to unforeseen circumstances (weather, strikes, courier issues, etc.). 
                We will keep you informed in such cases.
              </p>
            </section>

            <section className="policy-section">
              <h2>Incorrect Address</h2>
              <p>
                Please ensure that your shipping address and contact details are accurate. We are not responsible 
                for delays or losses due to incorrect or incomplete addresses.
              </p>
            </section>

            <section className="policy-section">
              <h2>Contact Information</h2>
              <p>For any queries or concerns regarding your payment, refund, or shipping, please reach out to us:</p>
              <div className="contact-info">
                <p>📧 <strong>sales@payinfintech.com</strong></p>
                {/* <p>📞 <strong>[Your customer care number]</strong></p> */}
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShippingPolicy;